export const SECONDARY_NAV = 'secondarynav';
export const SKY_MILES_NAV = 'sky-miles';
export const MORE_NAV = 'more';
